import { Masks } from "@hooks/functions/Masks/Masks";

export function RaffleDefaultNumberHowItWorksDrawRandom() {
  return (
    <>
      {/* Summary */}
      <div className="col-md-12">
        <h5 className="fw-bold">Sorteio Aleatório.</h5>
        <span>
          Na modalidade de Sorteio Aleatório o Sistema randomiza um ticket
          adquirido e o torna ganhador.
        </span>
      </div>
      {/* How it Works -> Examples */}
      <div className="col-md-12 mt-3">
        <h5 className="fw-bold">Como Funciona?</h5>
        <div className="d-flex flex-column gap-2">
          <li>
            Para esta modalidade o número sorteado será aleatoriamente
            selecionado dentre os tickets vendidos.
          </li>
        </div>
      </div>
      {/* Finishing */}
      <div className="col-md-12 mt-3">
        <p>
          Caso haja quaisquer dúvidas, entre em contato com o nosso Suporte.
        </p>
      </div>
    </>
  );
}
